// Generated by purs version 0.15.15
var LineJoinArcs = /* #__PURE__ */ (function () {
    function LineJoinArcs() {

    };
    LineJoinArcs.value = new LineJoinArcs();
    return LineJoinArcs;
})();
var LineJoinBevel = /* #__PURE__ */ (function () {
    function LineJoinBevel() {

    };
    LineJoinBevel.value = new LineJoinBevel();
    return LineJoinBevel;
})();
var LineJoinMiter = /* #__PURE__ */ (function () {
    function LineJoinMiter() {

    };
    LineJoinMiter.value = new LineJoinMiter();
    return LineJoinMiter;
})();
var LineJoinMiterClip = /* #__PURE__ */ (function () {
    function LineJoinMiterClip() {

    };
    LineJoinMiterClip.value = new LineJoinMiterClip();
    return LineJoinMiterClip;
})();
var LineJoinRound = /* #__PURE__ */ (function () {
    function LineJoinRound() {

    };
    LineJoinRound.value = new LineJoinRound();
    return LineJoinRound;
})();
var showStrokeLineJoin = {
    show: function (v) {
        if (v instanceof LineJoinArcs) {
            return "LineJoinArcs";
        };
        if (v instanceof LineJoinBevel) {
            return "LineJoinBevel";
        };
        if (v instanceof LineJoinMiter) {
            return "LineJoinMiter";
        };
        if (v instanceof LineJoinMiterClip) {
            return "LineJoinMiterClip";
        };
        if (v instanceof LineJoinRound) {
            return "LineJoinRound";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.StrokeLineJoin (line 18, column 10 - line 23, column 37): " + [ v.constructor.name ]);
    }
};
var printStrokeLineJoin = function (v) {
    if (v instanceof LineJoinArcs) {
        return "arcs";
    };
    if (v instanceof LineJoinBevel) {
        return "bevel";
    };
    if (v instanceof LineJoinMiter) {
        return "miter";
    };
    if (v instanceof LineJoinMiterClip) {
        return "miter-clip";
    };
    if (v instanceof LineJoinRound) {
        return "round";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.StrokeLineJoin (line 26, column 23 - line 31, column 27): " + [ v.constructor.name ]);
};
var eqStrokeLineJoin = {
    eq: function (x) {
        return function (y) {
            if (x instanceof LineJoinArcs && y instanceof LineJoinArcs) {
                return true;
            };
            if (x instanceof LineJoinBevel && y instanceof LineJoinBevel) {
                return true;
            };
            if (x instanceof LineJoinMiter && y instanceof LineJoinMiter) {
                return true;
            };
            if (x instanceof LineJoinMiterClip && y instanceof LineJoinMiterClip) {
                return true;
            };
            if (x instanceof LineJoinRound && y instanceof LineJoinRound) {
                return true;
            };
            return false;
        };
    }
};
export {
    LineJoinArcs,
    LineJoinBevel,
    LineJoinMiter,
    LineJoinMiterClip,
    LineJoinRound,
    printStrokeLineJoin,
    eqStrokeLineJoin,
    showStrokeLineJoin
};
